module.exports = __webpack_public_path__ + "static/media/(H)-08-Capim-Dourado-bijuterias.2fbd42a3.jpg";